export default "__VITE_ASSET__USNN9Yw9__"